import { gql } from '@apollo/client';

export default gql`
  query inspections(
    $placeId: ID
    $inspectionSubjectId: ID
    $identifier: String
    $sortBy: String
    $name: String
    $status: Int
    $page: Int
    $dueDateFrom: ISO8601DateTime
    $dueDateTo: ISO8601DateTime
    $doneAtFrom: ISO8601DateTime
    $doneAtTo: ISO8601DateTime
    $canceledAtFrom: ISO8601DateTime
    $canceledAtTo: ISO8601DateTime
    $notConditions: NotConditionsInput
    $inspectorId: ID
  ) {
    space {
      overInspectionsLimit
      adminRole
    }
    inspections(
      placeId: $placeId
      inspectionSubjectId: $inspectionSubjectId
      identifier: $identifier
      sortBy: $sortBy
      name: $name
      status: $status
      page: $page
      dueDateFrom: $dueDateFrom
      dueDateTo: $dueDateTo
      doneAtFrom: $doneAtFrom
      doneAtTo: $doneAtTo
      canceledAtFrom: $canceledAtFrom
      canceledAtTo: $canceledAtTo
      inspectorId: $inspectorId
      notConditions: $notConditions
    ) {
      perPage
      hasNextPage
      inspectionsTotalPages
      inspectionsTotal
      inspections {
        id
        identifier
        dueDate
        doneAt
        canceledAt
        periodCycle
        periodNumber
        name
        number
        status
        result
        overdue
        incoming
        inspectionSubject {
          id
          name
          serialNumber
        }
        place {
          id
          name
          street
          city
          zipCode
        }
      }
    }
  }
`;
